<template>
  <modal
    :title="setModel != null ? 'Update User Hotel ' : 'Add User Hotel'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="hotels == null || load"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem align-items-start"
        ref="form"
        v-if="hotels != null && !load"
      >
        <selectBox
          :title="'HotelId'"
          v-model.number="model.HotelId"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
          @change="selectHotel"
        >
          <template #search>
            <input
              type="text"
              placeholder="Ara"
              class="form-control small"
              v-model="searchHotel"
            />
          </template>
          <template #input>
            <template v-for="item in hotels">
              <option
                :value="item.Id"
                :key="item.Id"
                v-if="
                  countryId == item.CountryId &&
                    (searchHotel.length < 3 ||
                      item.Name.toUpperCase().indexOf(
                        searchHotel.toUpperCase()
                      ) > -1)
                "
                >{{ item.Name }}</option
              >
            </template>
          </template>
        </selectBox>
        <template
          v-if="
            model.HotelId != null &&
              hotels != null &&
              (hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 2 ||
                hotels.filter((x) => {
                  return x.Id == model.HotelId;
                })[0].SoftwareId == 1)
          "
        >
          <searchSelect
            :title="'Username'"
            v-model="model.P1"
            :errors="errors"
            :disabled="elektraUsers.length == 0"
            :data="
              $orderByArray(
                elektraUsers.map((x) => {
                  return {
                    value: x.Code,
                    text: x.Code + ' - ' + x.Name,
                  };
                }),
                'Name',
                false,
                false
              )
            "
          >
          </searchSelect>
        </template>
        <template
          v-if="
            model.HotelId != null &&
              hotels != null &&
              (hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 5 ||
                hotels.filter((x) => {
                  return x.Id == model.HotelId;
                })[0].SoftwareId == 11)
          "
        >
          <searchSelect
            :title="'Username'"
            v-model="model.P1"
            :errors="errors"
            :disabled="sednaUsers.length == 0"
            :data="
              $orderByArray(
                sednaUsers.map((x) => {
                  return {
                    value: x.Code,
                    text: x.Code + ' - ' + x.Name,
                  };
                }),
                'Name',
                false,
                false
              )
            "
          >
          </searchSelect>
        </template>
        <template
          v-if="
            model.HotelId != null &&
              hotels != null &&
              hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 6
          "
        >
          <formGroup
            :title="'Hotel Code'"
            v-model="model.P1"
            type="number"
            :errors="errors"
            :rules="{ required: true, max: 4000 }"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Username'"
            v-model="model.P2"
            :errors="errors"
            :rules="{ required: true, max: 4000 }"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Password'"
            v-model="model.P3"
            :errors="errors"
            :rules="{ max: 4000 }"
            @keydown.enter="save"
            @blur="model.P3 = model.P3==''?null:model.P3"
          ></formGroup>
          <formGroup
            :title="'TenantId'"
            v-model="model.P4"
            :errors="errors"
            :rules="{ max: 4000 }"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'HotelName'"
            v-model="model.P5"
            :errors="errors"
            :rules="{ max: 4000 }"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'LastCheckDate'"
            v-model="model.LastCheckDate"
            :errors="errors"
            :rules="{ max: 4000 }"
            @keydown.enter="save"
            disabled
          ></formGroup>
          <formGroup
            :title="'ErrorMessage'"
            as="textarea"
            v-model="model.ErrorMessage"
            :errors="errors"
            disabled
          ></formGroup>
          <formGroup
            :title="'ControlRequired'"
            as="checkbox"
            v-model="model.ControlRequired"
            :errors="errors"
            disabled
          ></formGroup>
        </template>
        <template
          v-if="
            model.HotelId != null &&
              diaUsers != null &&
              hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 3
          "
        >
          <searchSelect
            :title="'Username'"
            v-model="model.P1"
            :errors="errors"
            :disabled="diaUsers.length == 0"
            :rules="{ required: true }"
            :data="
              $orderByArray(
                diaUsers.map((x) => {
                  return {
                    value: x.Code,
                    text: x.Code + ' - ' + x.NameSurname,
                  };
                }),
                'Name',
                false,
                false
              )
            "
          >
          </searchSelect>
        </template>
        <template
          v-if="
            model.HotelId != null &&
              diaUsers != null &&
              hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 7
          "
        >
          <searchSelect
            :title="'Username'"
            v-model="model.P1"
            :errors="errors"
            :disabled="asyasoftUser.length == 0"
            :rules="{ required: true }"
            :data="
              $orderByArray(
                asyasoftUser.map((x) => {
                  return {
                    value: x.Code,
                    text: x.Code + ' - ' + x.Name + ' - ' + x.NameSurname,
                  };
                }),
                'Name',
                false,
                false
              )
            "
          >
          </searchSelect>
        </template>
        <template
          v-if="
            model.HotelId != null &&
              diaUsers != null &&
              hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 12
          "
        >
          <searchSelect
            :title="'Username'"
            v-model="model.P1"
            :errors="errors"
            :disabled="asyasoft9Users.length == 0"
            :rules="{ required: true }"
            :data="
              $orderByArray(
                asyasoft9Users.map((x) => {
                  return {
                    value: x.Kodu,
                    text: x.Kodu + ' - ' + x.Adi,
                  };
                }),
                'Name',
                false,
                false
              )
            "
          >
          </searchSelect>
        </template>
        <template
          v-if="
            model.HotelId != null &&
              rmosUsers != null &&
              hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 9
          "
        >
          <searchSelect
            :title="'Username'"
            v-model="model.P1"
            :errors="errors"
            :disabled="rmosUsers.length == 0"
            :rules="{ required: rmosUsers.length>0 }"
            :data="
              $orderByArray(
                rmosUsers.map((x) => {
                  return {
                    value: x.OUser_Id,
                    text: x.OUser_Kod + ' - ' + x.OUser_Ad+' '+x.OUser_Soyad,
                  };
                }),
                'OUser_Kod',
                false,
                false
              )
            "
          >
          </searchSelect>
        </template>
        <template
          v-if="
            model.HotelId != null &&
              hotels != null &&
              hotels.filter((x) => {
                return x.Id == model.HotelId;
              })[0].SoftwareId == 13
          "
        >
          <formGroup
            :title="'Username'"
            v-model="model.P1"
            type="text"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Password'"
            v-model="model.P2"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
          
        </template>
        <div class="row justify-content-end" style="margin:0 -5px 16px;">
          <div
            class="col-auto p-l-5 p-r-5"
            v-if="
              model.HotelId != null &&
                hotels.filter((x) => {
                  return x.Id == model.HotelId;
                })[0].SoftwareId == 6 &&
                setModel != null
            "
          >
            <Btn
              class="btn-sm btn-primary m-t-10"
              @click="checkUser"
              :disabled="processCheckUser"
              :process="processCheckUser"
              >Check User</Btn
            >
          </div>
          <div
            class="col-auto p-l-5 p-r-5"
            v-if="
              model.HotelId != null &&
                hotels.filter((x) => {
                  return x.Id == model.HotelId;
                })[0].SoftwareId == 6
            "
          >
            <Btn
              class="btn-sm btn-primary m-t-10"
              @click="testLogin"
              :disabled="processTestLogin"
              :process="processTestLogin"
              >Test Login</Btn
            >
          </div>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="hotels == null || load || process"
        :process="process"
        >{{ setModel != null ? "Update User Hotel" : "Add User Hotel" }}</Btn
      >
    </template>
  </modal>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
export default {
  props: {
    setModel: Object,
    userId: Number,
    customerId: Number,
  },
  components: { selectBox },
  data() {
    return {
      load: false,
      addSoftwareOpen: false,
      model: {
        Id: null,
        HotelId: null,
        UserId: this.userId,
        P1: null,
        P2: null,
        P3: null,
        P4: null,
        P5: null,
        LastCheckDate: "2025-02-07T23:58:07.107",
        ErrorMessage: "",
      },
      hotels: null,
      searchHotel: "",
      countryId: 228,
      process: false,
      processTestLogin: false,
      elektraUsers: [],
      processCheckUser: false,
      sednaUsers: [],
      diaUsers: [],
      asyasoftUser: [],
      asyasoft9Users: [],
      rmosUsers:[]
    };
  },
  created() {
    if (this.setModel != null) {
      this.model = { ...this.setModel,
        LastCheckDate:this.setModel.LastCheckDate==null || this.setModel.LastCheckDate.trim()==''?'':this.$moment(this.setModel.LastCheckDate).format('DD.MM.YYYY HH:mm')
       };
      this.model.UserId = this.userId;
    }
    this.$appAxiosAdmin
      .get(`Customers/` + this.customerId + `/Hotels`)
      .then((response) => {
        this.hotels = response.data;
        if (this.setModel != null) {
          this.selectHotel();
        }
      });
  },
  methods: {
    selectHotel() {
      if (
        this.model.HotelId != null &&
        (this.hotels.filter((x) => {
          return x.Id == this.model.HotelId;
        })[0].SoftwareId == 2 ||
          this.hotels.filter((x) => {
            return x.Id == this.model.HotelId;
          })[0].SoftwareId == 1)
      ) {
        this.elektraUsers = [];
        this.$appAxiosAdmin
          .get(`PMS/Users/` + this.model.HotelId)
          .then((response) => {
            this.elektraUsers = this.$orderByArray(
              response.data,
              "Name",
              false,
              false
            );
          })
          .catch((err) => {
            this.$isError(err);
          });
      }

      if (
        this.model.HotelId != null &&
        (this.hotels.filter((x) => {
          return x.Id == this.model.HotelId;
        })[0].SoftwareId == 5 ||
          this.hotels.filter((x) => {
            return x.Id == this.model.HotelId;
          })[0].SoftwareId == 11)
      ) {
        this.sednaUsers = [];
        this.$appAxiosAdmin
          .get(`PMS/Users/` + this.model.HotelId)
          .then((response) => {
            this.sednaUsers = this.$orderByArray(
              response.data,
              "Name",
              false,
              false
            );
          })
          .catch((err) => {
            this.$isError(err);
          });
      }

      if (
        this.model.HotelId != null &&
        this.hotels.filter((x) => {
          return x.Id == this.model.HotelId;
        })[0].SoftwareId == 3
      ) {
        this.diaUsers = [];
        this.$appAxiosAdmin
          .get(`PMS/Users/` + this.model.HotelId)
          .then((response) => {
            this.diaUsers = this.$orderByArray(
              response.data,
              "NameSurname",
              false,
              false
            );
          })
          .catch((err) => {
            this.$isError(err);
          });
      }

      if (
        this.model.HotelId != null &&
        this.hotels.filter((x) => {
          return x.Id == this.model.HotelId;
        })[0].SoftwareId == 7
      ) {
        this.diaUsers = [];
        this.$appAxiosAdmin
          .get(`PMS/Users/` + this.model.HotelId)
          .then((response) => {
            this.asyasoftUser = this.$orderByArray(
              response.data,
              "NameSurname",
              false,
              false
            );
          })
          .catch((err) => {
            this.$isError(err);
          });
      }

      if (
        this.model.HotelId != null &&
        this.hotels.filter((x) => {
          return x.Id == this.model.HotelId;
        })[0].SoftwareId == 12
      ) {
        this.diaUsers = [];
        this.$appAxiosAdmin
          .get(`PMS/12/Users/` + this.model.HotelId)
          .then((response) => {
            this.asyasoft9Users = this.$orderByArray(
              response.data,
              "Adi",
              false,
              false
            );
          })
          .catch((err) => {
            this.$isError(err);
          });
      }

      
      if (
        this.model.HotelId != null &&
        this.hotels.filter((x) => {
          return x.Id == this.model.HotelId;
        })[0].SoftwareId == 9
      ) {
        this.rmosUsers = [];
        this.$appAxiosAdmin
          .get(`PMS/9/Users/` + this.model.HotelId)
          .then((response) => {
            this.rmosUsers = response.data;
          })
          .catch((err) => {
            this.$isError(err);
          });
      }
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          if (
            this.model.HotelId != null &&
            this.hotels.filter((x) => {
              return x.Id == this.model.HotelId;
            })[0].SoftwareId == 3
          ) {
            this.model.P2 = this.diaUsers.filter(
              (x) => x.Code == this.model.P1
            )[0].Name;
            this.model.P3 = this.diaUsers.filter(
              (x) => x.Code == this.model.P1
            )[0].NameSurname;
          }
          
          if (
            this.rmosUsers.length>0 &&
            this.model.HotelId != null &&
            this.hotels.filter((x) => {
              return x.Id == this.model.HotelId;
            })[0].SoftwareId == 9
          ) {
            this.model.P2 = this.rmosUsers.filter(
              (x) => x.OUser_Id == this.model.P1
            )[0].OUser_Kod;
          }
          this.process = true;
          this.$appAxiosAdmin
            .put(`UserHotels`, {...this.model,LastCheckDate:null})
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The user hotel has been successfully updated."
                    : "The user hotel has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != null) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
    testLogin() {
      this.processTestLogin = true;
      this.$appAxiosAdmin
        .post(`PMS/Users/Login`, {
          HotelId: this.model.HotelId,
          HotelCode: this.model.P1,
          Username: this.model.P2,
          Password: this.model.P3,
        })
        .then(() => {
          this.processTestLogin = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully logined.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processTestLogin = false;
          this.$isError(err);
        });
    },
    checkUser() {
      this.processCheckUser = true;
      this.$appAxiosAdmin
        .get(`PMS/Users/Check/` + this.model.Id)
        .then((r) => {
          this.processCheckUser = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully check user.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
          this.model={
            ...r.data,
            LastCheckDate:r.data.LastCheckDate==null || r.data.LastCheckDate.trim()==''?'':this.$moment(r.data.LastCheckDate).format('DD.MM.YYYY HH:mm')
          };
          
                this.$emit("update", this.model);
        })
        .catch((err) => {
          this.processCheckUser = false;
          this.$isError(err);
        });
    },
  },
};
</script>

<style></style>
